/**
 * Phase 94 — MoM Navigator. Replaces the old Month/Quarter/FY toggle
 * everywhere in Finance (Dashboard Finance tab + the standalone Finance
 * ledgers page) with a single Month Selector — "All time" or one specific
 * calendar month — driving every chart, StatCard and ledger on the page.
 */
import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CalendarDays } from "lucide-react";
import { monthOptions } from "@/lib/finance";

export default function MonthSelector({ value, onChange, testId = "month-selector" }) {
  const options = monthOptions();
  return (
    <div className="inline-flex items-center gap-2">
      <CalendarDays size={14} className="text-slate-400" />
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="rounded-sm h-8 text-xs w-44 bg-white" data-testid={testId}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {options.map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}
